import React, {
  useContext,
  useReducer,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import reducer from './redux/reducer';
import { AuditoryProvider } from './auditory/provider';

const AppContext = React.createContext();

// Hook para acceder al contexto
const useAppContext = () => useContext(AppContext);

// Estado inicial
const initialState = {
  client: {},
  plans: '',
  leadData: {},
  insuredList: '',
  coverageAditional: [],
  address: {},
  plansFlex: [],
  plansFlexDiscount: [],
  planFlexSelected: {},
  discount: {},
  nonExistentDocument: false,
  subscriptionQuote: '',
  department: [],
  departmentLoaded: false,
  experiments: {
    campaignDays: false,
    newPrice: false,
    experimentCyber: {
      isActive: false,
      startDate: '',
      endDate: '',
    },
  },
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const globalContextValue = useMemo(
    () => ({
      dispatch, state,
    }),
    [dispatch, state],
  );

  return (
    <AuditoryProvider fallback={<div />}>
      <AppContext.Provider value={globalContextValue}>
        {children}
      </AppContext.Provider>
    </AuditoryProvider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export {
  AppProvider,
  useAppContext,
};
